<template>
  <v-container container>
    <v-list-item
      align="center"
      class="mt-0"
    >
      <v-list-item-content three-line>
        <v-list-item-title class="headline font-weight-black">Consulta de local de votação</v-list-item-title>
        <v-list-item-subtitle class="subtitle-1">{{election.name}}</v-list-item-subtitle>
        <v-list-item-subtitle class="title font-weight-black">{{election.secretaryName}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        align="center"
        sm="4"
        md="2"
      >
        <v-img
          contain
          max-width="184px"
          src="@/assets/img/logoHabitacao.png"
        />
      </v-col>
      <v-col
        sm="4"
        md="3"
        lg="2"
      >
        <h4 class="grey--text text--darken-1">Período de votação:</h4>
        <v-list-item-content>
          <v-list-item-subtitle class="body-2 font-regular">
            <v-icon class="pb-1 grey--text">event</v-icon>dia {{election.electionDate}}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="body-2 font-regular">
            <v-icon class="pb-1 grey--text">alarm</v-icon>das {{election.periodStart}} às {{election.periodEnd}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-col>
      <v-col
        sm="4"
        md="3"
        lg="2"
      >
        <h4 class="grey--text text--darken-1">Documentos necessários:</h4>
        <v-list-item-content>
          <v-list-item-subtitle class="body-2">
            <v-icon class="pb-1 green--text">check</v-icon>Documento com foto
          </v-list-item-subtitle>
          <v-list-item-subtitle class="body-2">
            <v-icon class="pb-1 green--text">check</v-icon>Título de eleitor
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-col>
    </v-row>
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        xs="12"
        sm="12"
        md="9"
        lg="6"
        xl="6"
      >
        <v-form
          v-model="valid"
          ref="form"
          class="searchBox"
        >
          <v-row
            class="ml-1 mr-1"
            no-gutters
          >
            <v-col class="mr-2">
              <v-text-field
                type="number"
                ref="voterId"
                v-model="voterId"
                name="name"
                label="Informe seu título de eleitor"
                :rules="[rules.required, rules.counter]"
                :maxlength="maxLength"
                @keyup.enter="search"
                @keypress="isNumber($event)"
                clearable
                filled
                autofocus
                required
                style="min-width: 160px"
              />
            </v-col>
            <v-col>
              <v-btn
                class="mt-2"
                depressed
                block
                color="primary"
                @click="search"
                :loading="loading"
                :disabled="loading"
                style="max-width: 128px"
              >
                <v-icon>place</v-icon>Consultar
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            v-show="this.showResult"
            class="ml-1 mr-1"
          >
            <v-col
              cols="12"
              class="grey lighten-4 searchBoxResult"
            >
              <div class="overline">Eleitor</div>
              <div class="body-2 mb-4">{{ $store.state.voter.name }}</div>
              <div class="overline">Local de votação</div>
              <div>{{ $store.state.voter.local.name }}</div>
              <div>{{ $store.state.voter.local.address }}</div>
            </v-col>
          </v-row>
          <Snackbar
            :active="snackbar.active"
            :color="snackbar.color"
            :text="snackbar.text"
            :duration=6000
            @close="snackbar.active = false"
          />
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';
import SnackbarMixin from '@/mixins/snackbar.mixin';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    Snackbar
  },
  mixins: [SnackbarMixin],
  data() {
    return {
      valid: false,
      voterId: '',
      maxLength: 12,
      loading: false,
      rules: {
        required: value => !!value || 'Campo obrigatório',
        counter: value =>
          (value && value.length === this.maxLength) || 'Deve conter 12 dígitos'
      }
    };
  },

  computed: {
    ...mapGetters('election', { election: 'mySelf' }),
    ...mapGetters('voter', ['showResult'])
  },
  watch: {
    voterId() {
      this.updateShowResult(false);
    }
  },

  mounted() {
    this.getElection({ idElection: this.$store.state.election.id });
  },
  methods: {
    ...mapMutations('voter', ['updateShowResult']),
    ...mapActions('voter', { getVoterById: 'get' }),
    ...mapActions('election', { getElection: 'get' }),
    async search() {
      if (this.isValid()) {
        this.loading = true;
        try {
          await this.getVoterById({
            idElection: 1,
            voterIdentifier: this.voterId
          });
        } catch (error) {
          this.showMessageError('Título de eleitor não encontrado.');
        } finally {
          this.loading = false;
        }
      }
    },
    isNumber(event) {
      if (
        /\D/.test(event.key) ||
        (this.voterId && this.voterId.length === this.maxLength)
      ) {
        event.preventDefault();
      }
    },
    isValid() {
      return this.$refs.form.validate();
    },
    showMessageError(message) {
      this.snackbar.text = message;
      this.snackbar.color = 'red';
      this.snackbar.active = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.headline {
  font-size: 20px;
}

.title {
  color: $blue-prodam !important;
  text-transform: uppercase;
}

.subtitle {
  font-size: 16px;
}

.blue-prodam--text {
  color: $blue-prodam;
}

.searchBox {
  border-color: $blue-prodam;
  border-width: 2px;
  border-style: solid;
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  padding: 4px;
  font-size: 16px;
}

.searchBoxResult {
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-color: #c0cdcd !important;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
}
</style>
